import React, { useContext } from 'react';
import SessionContext from '@providers/Session/SessionContext';
import { Container } from './styles';
import TableWithContent from './TableWithContent';
import ChartWithContent from './ChartWithContent';

const RoamingReport: React.FC = () => {
  const { isRoot } = useContext(SessionContext);

  return (
    <Container>
      <ChartWithContent isRoot={isRoot} />
      <TableWithContent isRoot={isRoot} />
    </Container>
  );
};

export default RoamingReport;
